import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import UserBadge from '../../../common/components/UserBadge';
import app from 'flarum/forum/app';
export default class BlockListView extends Component {
  view() {
    if (!this.attrs.badges) {
      return null;
    }
    const badges = this.attrs.badges;
    return m("ul", {
      className: 'BadgeCategoryList'
    }, badges.map(badge => {
      return m("li", null, m(Link, {
        href: app.route('badges.item', {
          id: badge.id()
        }),
        className: 'BadgeContainer'
      }, m("div", {
        className: 'BadgeContainerInfo'
      }, m(UserBadge, {
        badge: badge,
        tooltip: false
      }), m("p", {
        className: 'BadgeDescription'
      }, badge.description()), m("p", null, app.translator.trans('v17development-flarum-badges.forum.badge.earned_count', {
        count: badge.earnedAmount()
      })))));
    }));
  }
}
flarum.reg.add('itqan-user-badges', 'forum/components/BadgeCategoryList/BlockListView', BlockListView);